import { render, staticRenderFns } from "./BuyBoxInfoModal.vue?vue&type=template&id=3534731a&scoped=true"
import script from "./BuyBoxInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxInfoModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxInfoModal.vue?vue&type=style&index=0&id=3534731a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534731a",
  null
  
)

export default component.exports